import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { AccountTypeEnum, DiscoveryStatusEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Injectable({
  providedIn: 'root'
})
export class FinishedDiscoveryGuardService   {
  constructor(public router: Router, public localStorageService: AbstractLocalStorageService, public personalUserDataService: AbstractPersonalUserDataService) { }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log('this.personalUserDataService.getLoggedInUserPersonalData()?.discoveryStatus '+this.personalUserDataService.getLoggedInUserPersonalData()?.discoveryStatus);

    if (!this.personalUserDataService.getLoggedInUserPersonalData()){
      return false;
    }
      
    const userData = this.personalUserDataService.getLoggedInUserPersonalData();

    // B2C users (CAREER_INDEPENDENT) skip firstTime/discovery entirely
    if (userData?.accountType === AccountTypeEnum.CAREER_INDEPENDENT || userData?.accountType === AccountTypeEnum.CAREER_INDEPENDENT_US) {
      return true;
    }

    if (userData?.discoveryStatus !== DiscoveryStatusEnum.DONE) {
      this.localStorageService.write<string>(LocalStorageKeys.returnUrl, state.url);
      // this.router.navigate([NAVIGATION_ROUTES.login]);
            this.router.navigate([NAVIGATION_ROUTES.app.firstTimeLogin], { state: { redirect: state.url } });
      return false;
    } else {
      return true;
    }
    
  }}